import React from 'react';
import { useQuery } from 'react-query';
import PaymentTokensView, { PaymentTokensViewProps } from './PaymentTokensView';
import { PaymentTokenItem } from './PaymentTokenItem';
import { getPaymentsByMeterId, PaymentDetailAPI } from '../../../../features/meter/services/meterAPI';

export interface PaymentTokensPresenterProps {
  deviceId?: string;
  maxHeight?: string;
  autoRefresh?: boolean;
  refreshInterval?: number;
}

function mapPaymentToToken(payment: PaymentDetailAPI): PaymentTokenItem {
  return {
    id: payment.paymentID,
    token: payment.codeId || payment.transactionId || payment.paymentID,
    amount: payment.money,
    currency: payment.currency || 'XOF',
    status: payment.status === 'FINISHED' || payment.status === 'consommé' ? 'consommé' : 'généré',
    createdAt: payment.timePayment,
    expiresAt: '',
    description: payment.info || undefined,
    kwhValue: payment.kwh,
    dayValue: payment.day,
    typePayment: payment.typePayment,
  };
}

export default function PaymentTokensPresenter({
  deviceId,
  maxHeight = '300px',
  autoRefresh = true,
  refreshInterval = 60000
}: PaymentTokensPresenterProps) {
  const query = useQuery({
    queryKey: ['payments', deviceId],
    queryFn: () => getPaymentsByMeterId(deviceId!),
    enabled: !!deviceId,
    refetchInterval: autoRefresh ? refreshInterval : false,
  });

  const tokens = query.data?.map(mapPaymentToToken) ?? [];

  const viewProps: PaymentTokensViewProps = {
    tokens,
    isLoading: query.isLoading,
    maxHeight
  };

  return <PaymentTokensView {...viewProps} />;
}
